// src/App.js - Updated to import and orchestrate modular components
import React from 'react';
import {Routes,Route} from 'react-router-dom';
import './App.css'; // Global styles
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import ShoppingCart from './components/ShoppingCart';
import Blog from './components/Blog'; // New import
import ProductImage from './assets/images/zenzzz-jar-landing-3.png'; // Import product image
import BlogPost from './components/BlogPost';   // ← add this
import Layout from './components/Layout';   // ← new
import CheckoutPage from './pages/CheckoutPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import TermsPage from './pages/TermsPage';
import ScrollToTop from './components/ScrollToTop';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import MetaPixel from './components/MetaPixel';
import GoogleAnalytics from './components/GoogleAnalytics';


const App = () => {
    return (

        <div className="App">
            {/* ← Header/Footer outside Routes */}
            <GoogleAnalytics />
            <MetaPixel />
            <ScrollToTop />
            <Routes>

                <Route element={<Layout />}>                     {/* ← THIS IS THE KEY */}
                    <Route path="/" element={
                        <>
                            <Hero price={39.99} productImage={ProductImage} />
                            <Features />
                            <Testimonials />
                            <Blog />
                            <ShoppingCart price={39.99} productImage={ProductImage} />
                        </>
                    } />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/refund" element={<RefundPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/contact" element={<ContactPage/>} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/faq" element={<FAQPage  />} />
                </Route>


            </Routes>


</div>
    );
};

export default App;